export class PlayerUnit{
    constructor(unitType, playerId){
        this.unitType = unitType;
        this.ownedByPlayerId = playerId;
    }
}